// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1JR_l","infected":"Cards_infected__La8QR","recovered":"Cards_recovered__aXKyn","deaths":"Cards_deaths__E0A71"};